import { render, staticRenderFns } from "./LongServiceLeaveSettings.vue?vue&type=template&id=0ccb4c78&scoped=true"
import script from "./LongServiceLeaveSettings.vue?vue&type=script&lang=js"
export * from "./LongServiceLeaveSettings.vue?vue&type=script&lang=js"
import style0 from "./LongServiceLeaveSettings.vue?vue&type=style&index=0&id=0ccb4c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccb4c78",
  null
  
)

export default component.exports